import { TextareaAutosize, TextField } from "@mui/material"
import { useState } from "react";

const CustomFormParagraphField = ({ item, index, ...props }) => {

    const [inputValue, setInputValue] = useState('')

    return (
        <TextareaAutosize
            placeholder={item?.placeHolder || 'Input'}
            required={item?.required || false}
            onChange={(e) => {
                setInputValue(e.target.value)
            }}
            onBlur={() => {
                item['value'] = inputValue
            }}
            style={{
                fontFamily: 'Public sans',
                padding: 15,
                borderRadius: 6,
                width: '100%',
                
            }}
            {...props}
        />
    )
};

export default CustomFormParagraphField;